import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

class SyncConfigurationsTabsComponent extends Component {

    renderTabs(listOfTabs) {
        return (<ul className={'tabs '+this.props.activeTab}>{listOfTabs}</ul>);
    }

    render() {
        const { t } = this.props;
        const tabs = []
        tabs.push(<li key="/sheets-sync"><Link className="tab-button -first" to="/sheets-sync">{t('sync_tabs.synchronizations')}</Link></li>);
        tabs.push(<li key="/agency/conections/export"><Link className="tab-button -first" to="/agency/conections/export">{t('sync_tabs.connections')}</Link></li>);

        return (
            <div className="filters">
                {this.renderTabs(tabs)}
            </div>
        )
    }
}

export const SyncConfigurationsTabs = withTranslation()(SyncConfigurationsTabsComponent);